angular.module('impactx.userdialog').controller('UserCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    '$mdDialog',
    '$routeParams',
    'ToolbarService',
    'PartialDialogsService',
    'TranslationService',
    UserCtrl
]);

function UserCtrl ($scope, dataGen, BackService, ToastService, $mdDialog, $routeParams, ToolbarService, PartialDialogsService, TranslationService) {
    var self = this;
    self.errorList = [];
    $scope.userId = $routeParams.id;
    if (!$scope.userId) {
        $scope.userId = 0;
    }
    $scope.productmenu = {menuitems: [{label: 'Placeholder', view: 'lobby'}]};

    $scope.showToolbar = false;
    $scope.toggleToolbar = function () {
        $scope.showToolbar = !$scope.showToolbar;
    };
    $scope.getPageData = function () {
        dataGen.getData($scope, {id: $scope.userId}, "/user/view").then(function () {
            defineButtons();
        });
    };
    $scope.savePageData = function ($event, showOthers) {
        if(!$scope.data.userCard.imageUrl) {
            $scope.data.userCard.imageUrl = '';
        }
        var dataObj = {
            data: $scope.data
        };
        return dataGen.post({}, dataObj, "/user/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            if(data && data.data && data.data.id) {
                var userId = data.data.id;
                PartialDialogsService.addNew(PartialDialogsService.TYPE.USER, Number($scope.userId), userId);
                if(showOthers)
                {
                    PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.USER, userId, 'personaldata', undefined, true);
                }
                else
                {
                    PartialDialogsService.addDialog(PartialDialogsService.TYPE.USER, userId, 'personaldata');
                    PartialDialogsService.redirectToList(PartialDialogsService.TYPE.USER, undefined);
                }
            }
            else {
                BackService.back();
            }
        });
    };

    $scope.savePageDataBackToList = function ($event) {
        return $scope.savePageData($event, false);
    };

    $scope.savePageDataOtherDialogs = function ($event) {
        return $scope.savePageData($event, true);
    };

    $scope.deleteUser = function () {
        var data = $scope.data;
        var userId, resultScope = {},
            dataObj;

        if (data) {
            userId = data.userId;

            if (!(userId > 0)) {
                userId = $scope.userId
            }

            if (userId > 0) {
                var selectedIdsAsInteger = [];
                selectedIdsAsInteger.push(userId);

                dataGen.postAsForm(resultScope, {usrIds: selectedIdsAsInteger}, "/user/delete").then(function (backendData) {
                    BackService.back();
                    ToastService.openStandardToastAfterDeleteSuccess(resultScope, backendData);
                });
            }
            else {
                ToastService.openActionToast("Can no delete user (Unknown ID).");
            }
        }
    };

    $scope.getPageData();

    $scope.productmenu = {menuitems: [{label: 'Placeholder', view: 'lobby'}]};
    this.editAddressPreferences = function (ev) {
        $mdDialog.show({
            controller: 'AddressPreferencesDialogCtrl',
            controllerAs: 'ctrl',
            templateUrl: 'modules/profile/templates/address-preferences.tmpl.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                addressField: angular.copy($scope.data.useraddress.addressField, {}),
                translations: $scope.trns
            }
        }).then(function (response) {
            $scope.data.useraddress.addressField.addressFields = response.possible;
            $scope.data.useraddress.addressField.selected = response.selected;
        });
    };

    $scope.restrictPreferredUIType = function (selected) {
        if (selected) {
            var tmpScope = {};
            dataGen.getData(tmpScope, {comId: selected.id}, '/user/input/preferredUIType').then(function (result) {
                if (impactX.isDefined(result, 'data')) {
                    $scope.data.userlogin.preferredUIType = result.data;
                }
            })
        }
    };

    $scope.setUserPrototype = function (newValue) {
        $scope.data.userlogin.prototype.value = newValue;
    };

    this.canApproveAndDeny = function() {
        return $scope.data.userlogin.registrationStatus == 2;
    };

    this.approve = function() {
        var dataObj = {
            usrId: $scope.userId
        };
        dataGen.postAsForm({}, dataObj, "/user/registration/approve").then(function() {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    this.deny = function() {
        var dataObj = {
            usrId: $scope.userId
        };
        dataGen.postAsForm({}, dataObj, "/user/registration/deny").then(function() {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };


    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageDataBackToList,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.saveAndForward,
                action: $scope.savePageDataOtherDialogs,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.deleteUser,
                type: 'dialogaction',
                condition: canDelete
            },
            {label: $scope.trns.approve, action: self.approve, condition: self.canApproveAndDeny, process: 'SelfRegistrationUnlock'},
            {label: $scope.trns.deny, action: self.deny, condition: self.canApproveAndDeny, process: 'SelfRegistrationUnlock'}
        ];
        self.collectErrors();
        ToolbarService.setButtons(buttonDefinition);
    }

    function hasErrors() {
        return self.errorList.length;
    }

    function getErrors() {
        return self.errorList;
    }

    self.collectErrors = function () {
        self.errorList.length = 0;
        if (passwordsDiffer()) {
            self.errorList.push($scope.trns.passwordsDontMatch);
        }
        if ($scope.data && $scope.data.userCard && $scope.data.userlogin && $scope.data.userCard.maxNumberOfUsersReached && !$scope.data.userlogin.disabled.value) {
            var lastValidDate = null;
            if ($scope.data.userlogin.lastValidDate.dateValue) {
                lastValidDate = ($scope.data.userlogin.lastValidDate.dateValue instanceof Date) ? $scope.data.userlogin.lastValidDate.dateValue :
                    new Date($scope.data.userlogin.lastValidDate.dateValue);
            }
            var lastValidDateInPast = false;
            if (lastValidDate != null) {
                lastValidDateInPast =  new Date(lastValidDate.toDateString()) < new Date(new Date().toDateString());
            }
            if (!lastValidDateInPast) {
                self.errorList.push($scope.data.userCard.maxNumberOfUsersReachedMessage);
            }
        }

    };

    function passwordsDiffer() {
        if (!$scope.data.userlogin.password || !$scope.data.userlogin.passwordRepeat) {
            return false;
        }
        if (!$scope.data.userlogin.password.value && !$scope.data.userlogin.passwordRepeat.value) {
            return false;
        }
        else {
            return $scope.data.userlogin.password.value !== $scope.data.userlogin.passwordRepeat.value;
        }
    }

    function canDelete() {
        return $scope.data.user.canDelete;
    }

    this.homeOfficeChange = function (event) {
        if (!$scope.data.useraddress.homeOfficeUser.value) {
            self.showHomeOfficeAddressDialog(event, true)
        }
    };

    this.deleteNoOrderValue = function (id, index) {
        dataGen.postAsForm({}, {id: id}, "/user/deletenoorder").then(function (data) {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            $scope.data.user.noOrderValues.splice(index, 1);
        });
    }

    this.showHomeOfficeAddressDialog = function(event, wasNotSelected) {
        $mdDialog.show({
            templateUrl: 'modules/address/templates/addressdialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            controller: "AddressDialogCtrl",
            controllerAs: 'ctrl',
            hasBackdrop: true,
            disableParentScroll: true,
            multiple: true,
            locals: {
                data: JSON.parse(JSON.stringify($scope.data.useraddress.homeOfficeAddress)),
                trns: $scope.trns,
                label_title:  $scope.data.useraddress.homeOfficeAddress.labelAddress,
                addressType: 'delivery',
                typesAvail: {delivery: true},
                showInheritanceOptions: true,
                owningComOptions: false,
                disableOwningCom: true,
                saveDirect: false,
                personalData: false,
                addresses: [],
                restricted: false,
                regionCode: null
            }
        }).then(function(answer) {
            if(!isUndefined(answer) && !isUndefined(answer.addressId)) {
                $scope.data.useraddress.homeOfficeAddress = answer;
            }
            else if(wasNotSelected) {
                $scope.data.useraddress.homeOfficeUser.value = false;
            }
        });
    };
}